import { useState, useMemo, useCallback } from "react";
import { useGetApprovalOrdersQuery } from "../../../api/endpoints/approvalOrders";
import { useLanguage } from "../../../contexts/LanguageContext";

export const useApprovalOrders = () => {
  const { th } = useLanguage();
  const [selectedTab, setSelectedTab] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data: response,
    isFetching: isLoading,
    refetch,
  } = useGetApprovalOrdersQuery({ 
    approvalStatus: selectedTab,
    searchTerm: searchTerm 
  });

  const orders = response?.data?.orders ?? [];
  const isParentDealer = response?.data?.isParentDealer ?? false;

  // Filtre alanları tanımı
  const filterFields = useMemo(() => [
    {
      field: 'searchTerm',
      headerName: th('approvalOrders.filter.searchTerm'),
      type: 'text',
      filterPlaceholder: th('approvalOrders.filter.searchPlaceholder')
    }
  ], [th]);

  // Filtreleri uygula
  const handleApplyFilters = useCallback((filters) => {
    setSearchTerm(filters.searchTerm || "");
  }, []);

  // Filtreleri sıfırla
  const handleResetFilters = useCallback(() => {
    setSearchTerm("");
  }, []);

  return {
    selectedTab,
    setSelectedTab,
    orders,         
    isLoading,
    refetch,
    isParentDealer,
    searchTerm,
    setSearchTerm,
    filterFields,
    handleApplyFilters,
    handleResetFilters,
  };
};
